import React from 'react'
import { Grid, Typography, Chip, Button } from '@material-ui/core'
import MUIDataTable from 'mui-datatables'
import { FormattedMessage, useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import Configuration from '../../../../Services/Api/Configuration'
import UserServices from '../../../../Services/Consumers/UserServices'
import { filterData } from '../../../../utils/helpers'
import { useKeycloak } from '@react-keycloak/web'
import PageTitle from '../../PageTitle/PageTitle'
import { FormLoader } from '../../../Loader/FormLoader'
import { useStyles } from './Styles'
import CurrencyMenu from './CurrencyMenu'
import { NamedRoutes } from '../../../../routes'
import Moment from 'react-moment'
import 'moment/locale/ar-ly'

export default function CurrenciesContent({ handleNotificationCall, locale }) {
  let classes = useStyles()
  const intl = useIntl()
  const history = useHistory()
  const { keycloak } = useKeycloak()
  const [count, setCount] = React.useState(0)
  const [currentFilter, setCurrentFilter] = React.useState(null)
  const rowsPerPage = Configuration.User_Config.userCurrenciesLimit || 10
  const [sortOrder, setSortOrder] = React.useState({})
  const [data, setData] = React.useState(['Loading Data...'])
  const [loadedData, setLoadedData] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(false)
  const [canCreate, setCanCreate] = React.useState(false)

  const renderBooleanChip = (value) => (
    <Chip
      label={intl.formatMessage({ id: !!value ? 'Common.Enabled' : 'Common.Disabled' })}
      size="small"
      className={!!value ? classes.activeChip : classes.inactiveChip}
    />
  )

  const columns = [
    {
      name: 'name',
      label: intl.formatMessage({ id: 'Currencies.List.Table.Name' }),
      options: {
        filter: true,
        filterType: 'textField',
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='Currencies.List.Table.Name' />:
                <span>{v}</span>
              </div>
            )
          }
        }
      }
    },
    {
      name: 'key',
      label: intl.formatMessage({ id: 'Currencies.List.Table.Key' }),
      options: {
        filter: true,
        filterType: 'textField',
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='Currencies.List.Table.Key' />:
                <span>{v}</span>
              </div>
            )
          }
        }
      }
    },
    {
      name: 'code',
      label: intl.formatMessage({ id: 'Currencies.List.Table.Code' }),
      options: {
        filter: true,
        filterType: 'textField',
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='Currencies.List.Table.Code' />:
                <span>{v}</span>
              </div>
            )
          }
        }
      }
    },
    {
      name: 'enable_core',
      label: intl.formatMessage({ id: 'Currencies.List.Table.EnableCore' }),
      options: {
        filter: true,
        filterType: 'dropdown',
        filterOptions: {
          names: ['1', '0'],
          renderValue: (value) => {
            if (value === '1') {
              return intl.formatMessage({ id: 'Common.Enabled' })
            }
            return intl.formatMessage({ id: 'Common.Disabled' })
          }
        },
        customBodyRender: (value) => renderBooleanChip(value),
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='Currencies.List.Table.EnableCore' />:
                <span>{v === '1' ? intl.formatMessage({ id: 'Common.Enabled' }) : intl.formatMessage({ id: 'Common.Disabled' })}</span>
              </div>
            )
          }
        }
      }
    },
    {
      name: 'core_sender_id',
      label: intl.formatMessage({ id: 'Currencies.List.Table.CoreSenderId' }),
      options: {
        filter: false
      }
    },
    {
      name: 'core_sender_default_name',
      label: intl.formatMessage({ id: 'Currencies.List.Table.CoreSenderDefaultName' }),
      options: {
        filter: false
      }
    },
    {
      name: 'core_sender_password',
      label: intl.formatMessage({ id: 'Currencies.List.Table.CoreSenderPassword' }),
      options: {
        filter: false
      }
    },
    {
      name: 'core_service_code',
      label: intl.formatMessage({ id: 'Currencies.List.Table.CoreServiceCode' }),
      options: {
        filter: false
      }
    },
    {
      name: 'core_settlement_amount_code',
      label: intl.formatMessage({ id: 'Currencies.List.Table.CoreSettlementAmountCode' }),
      options: {
        filter: false
      }
    },
    {
      name: 'enable_none_core',
      label: intl.formatMessage({ id: 'Currencies.List.Table.EnableNoneCore' }),
      options: {
        filter: true,
        filterType: 'dropdown',
        filterOptions: {
          names: ['1', '0'],
          renderValue: (value) => {
            if (value === '1') {
              return intl.formatMessage({ id: 'Common.Enabled' })
            }
            return intl.formatMessage({ id: 'Common.Disabled' })
          }
        },
        customBodyRender: (value) => renderBooleanChip(value),
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='Currencies.List.Table.EnableNoneCore' />:
                <span>{v === '1' ? intl.formatMessage({ id: 'Common.Enabled' }) : intl.formatMessage({ id: 'Common.Disabled' })}</span>
              </div>
            )
          }
        }
      }
    },
    {
      name: 'none_core_sender_id',
      label: intl.formatMessage({ id: 'Currencies.List.Table.NoneCoreSenderId' }),
      options: {
        filter: false
      }
    },
    {
      name: 'none_core_sender_default_name',
      label: intl.formatMessage({ id: 'Currencies.List.Table.NoneCoreSenderDefaultName' }),
      options: {
        filter: false
      }
    },
    {
      name: 'none_core_sender_password',
      label: intl.formatMessage({ id: 'Currencies.List.Table.NoneCoreSenderPassword' }),
      options: {
        filter: false
      }
    },
    {
      name: 'none_core_service_code',
      label: intl.formatMessage({ id: 'Currencies.List.Table.NoneCoreServiceCode' }),
      options: {
        filter: false
      }
    },
    {
      name: 'none_core_settlement_amount_code',
      label: intl.formatMessage({ id: 'Currencies.List.Table.NoneCoreSettlementAmountCode' }),
      options: {
        filter: false
      }
    },
    {
      name: 'created_at',
      label: intl.formatMessage({ id: 'Currencies.List.Table.CreatedAt' }),
      options: {
        filter: false,
        sort: true,
        customBodyRenderLite: (dataIndex) => {
          return data[dataIndex] &&
            <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'}
              format="Do MMMM YYYY h:mm a">{data[dataIndex].created_at}</Moment>
        }
      }
    },
    {
      name: '',
      options: {
        filter: false,
        print: false,
        viewColumns: false,
        download: false,
        customBodyRenderLite: (dataIndex) => (
          data[dataIndex] &&
          <CurrencyMenu
            index={dataIndex}
            data={data}
            setData={setData}
            setCount={setCount}
          />
        )
      }
    }
  ]

  const xhrRequest = (page, nextSortOrder = {}, clear) => {
    if (!!keycloak?.authenticated) {
      setIsLoading(true)
      if (!!loadedData[page] && !!loadedData[page].length && !clear) {
        setData(loadedData[page])
        setIsLoading(false)
      } else {
        UserServices.getCurrencies({
          headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` },
          params: filterData({
            page,
            limit: rowsPerPage,
            ...currentFilter
          })
        }).then((result) => {
          if ((!!result && result.response && result.response.status !== 200) || !result || result.status !== 200) {
            let message = intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' })
            if (result?.response?.status === 403) {
              message = intl.formatMessage({ id: 'BasicInfo.AccessDeniedAlert' })
            } else if (result?.response?.data?.status?.errors && result?.response?.status === 422) {
              message = result.response.data.status.errors
            } else if (result?.response?.data?.status?.message) {
              message = result.response.data.status.message
            }
            handleNotificationCall({
              type: 'defence',
              message,
              color: 'error'
            }, 'error')
            setData([])
          } else {
            setCanCreate(true)
            if (!!result && !!result.data && !!result.data.data) {
              let newData = result.data.data
              setSortOrder(nextSortOrder)
              let sortField = nextSortOrder.name
              let sortDir = nextSortOrder.direction

              if (sortField) {
                newData = newData.sort((a, b) => {
                  if (a[sortField] < b[sortField]) {
                    return 1 * (sortDir === 'asc' ? -1 : 1)
                  } else if (a[sortField] > b[sortField]) {
                    return -1 * (sortDir === 'asc' ? -1 : 1)
                  } else {
                    return 0
                  }
                })
              }

              setData(newData)
              let prevData = loadedData
              prevData[page] = newData
              setLoadedData(prevData)
              setCount(result.data.meta?.total || newData.length)
            }
          }
        }).catch(() => {
          handleNotificationCall({
            type: 'defence',
            message: intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' }),
            color: 'error'
          }, 'error')
        }).finally(() => {
          setIsLoading(false)
        })
      }
    }
  }

  const getCurrenciesListData = (page) => {
    xhrRequest(page)
  }

  const sort = (page, nextSortOrder) => {
    setSortOrder(nextSortOrder)
    let sortField = nextSortOrder.name
    let sortDir = nextSortOrder.direction
    let newData = data

    if (sortField) {
      newData = newData.sort((a, b) => {
        if (a[sortField] < b[sortField]) {
          return 1 * (sortDir === 'asc' ? -1 : 1)
        } else if (a[sortField] > b[sortField]) {
          return -1 * (sortDir === 'asc' ? -1 : 1)
        } else {
          return 0
        }
      })
    }
    setData([...newData])
  }

  React.useEffect(() => {
    getCurrenciesListData(1)
  },  // eslint-disable-next-line react-hooks/exhaustive-deps
    [])

  const changePage = (page, nextSortOrder) => {
    xhrRequest(++page, nextSortOrder)
  }

  const changeFilter = (applyFilters) => {
    setLoadedData([])
    let filterList = applyFilters()
    let filters = {}
    filterList.forEach((filterItem, index) => {
      if (!!filterItem.length) {
        const columnName = columns[index].name
        if (columnName === 'enable_core' && filterItem[0] !== '' && filterItem[0] !== undefined) {
          filters.enable_core = filterItem[0]
        } else if (columnName === 'enable_none_core' && filterItem[0] !== '' && filterItem[0] !== undefined) {
          filters.enable_none_core = filterItem[0]
        } else if (filterItem[0] && filterItem[0].length >= 1) {
          filters[columnName] = filterItem[0]
        }
      }
    })

    setCurrentFilter(filters)
  }

  React.useEffect(() => {
    if (!!currentFilter) {
      xhrRequest(1, {}, true)
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentFilter])

  const options = {
    filter: true,
    filterType: 'dropdown',
    responsive: 'simple',
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    serverSide: true,
    count: count,
    search: false,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [],
    sortOrder: sortOrder,
    confirmFilters: true,
    downloadOptions: { filename: `${intl.formatMessage({ id: 'Sidebar.Links.Currencies' })}.csv`, separator: ',' },
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div className={classes.ApplyFilterWrapper}>
          <Button color='primary' variant="contained"
            onClick={() => changeFilter(applyNewFilters)}>
            <FormattedMessage id='Users.List.Table.ApplyFilters' /></Button>
        </div>
      )
    },
    onFilterChange: (column, filterList, type) => {
      if (type === 'chip') {
        setLoadedData([])
        let newFilters = () => (filterList)
        changeFilter(newFilters)
      }
    },
    textLabels: {
      body: {
        noMatch: intl.formatMessage({ id: 'Currencies.List.Table.NoResults' }),
        toolTip: intl.formatMessage({ id: 'Users.List.Table.Sort' })
      },
      pagination: {
        next: intl.formatMessage({ id: 'Users.List.Table.NextPage' }),
        previous: intl.formatMessage({ id: 'Users.List.Table.PreviousPage' }),
        rowsPerPage: intl.formatMessage({ id: 'Users.List.Table.RowsPerPage' }),
        displayRows: intl.formatMessage({ id: 'Users.List.Table.Of' })
      },
      toolbar: {
        search: intl.formatMessage({ id: 'Users.List.Table.Search' }),
        downloadCsv: intl.formatMessage({ id: 'Users.List.Table.Download' }),
        print: intl.formatMessage({ id: 'Users.List.Table.Print' }),
        viewColumns: intl.formatMessage({ id: 'Users.List.Table.ViewColumns' }),
        filterTable: intl.formatMessage({ id: 'Users.List.Table.FilterTable' })
      },
      filter: {
        all: intl.formatMessage({ id: 'Users.List.Table.All' }),
        title: intl.formatMessage({ id: 'Users.List.Table.FILTERS' }),
        reset: intl.formatMessage({ id: 'Users.List.Table.RESET' })
      },
      viewColumns: {
        title: intl.formatMessage({ id: 'Users.List.Table.ShowColumns' }),
        titleAria: intl.formatMessage({ id: 'Users.List.Table.ShowHideColumns' })
      }
    },
    onTableChange: (action, tableState) => {
      switch (action) {
        case 'changePage':
          changePage(tableState.page, tableState.sortOrder)
          break
        case 'sort':
          sort(tableState.page, tableState.sortOrder)
          break
        default:
          break
      }
    }
  }

  return (
    <>
      <PageTitle title={<FormattedMessage id='Currencies.Page.Title' />}
        button={!!canCreate && (
          <Button
            classes={{ root: classes.button }}
            variant="contained"
            size="large"
            color="primary"
            onClick={() => {
              history.push(NamedRoutes.workspace.currencies.add)
            }}
          >
            <FormattedMessage id='Currencies.Form.AddTitle' />
          </Button>
        )} />
      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.TableWrapper}>
          {isLoading && <FormLoader loading={true} />}
          <MUIDataTable
            title={
              <Typography variant="h6">
                <FormattedMessage id='Currencies.List.Table.Title' />
              </Typography>
            }
            data={data}
            columns={columns}
            options={options}
          />
        </Grid>
      </Grid>
    </>
  )
}
